<template>
  <v-card>
    <v-card-text class="pt-0">
      <v-container grid-list-md class="pa-0">
        <v-layout wrap>
          <v-flex xs4 sm3 lg2>
            <v-select
              v-model="query.condition"
              label="Standard"
              :items="[
                { text: 'All (AND)', value: 'and' },
                { text: 'Any (OR)', value: 'or' }
              ]"
              solo
              dense
            ></v-select>
          </v-flex>

          <v-flex xs8 sm9 lg10>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  style="width:30px;height:30px;"
                  fab
                  small
                  color="orange"
                  v-on="on"
                  @click="
                    query.rules.push({
                      _key: Date.now(),
                      field: '',
                      operator: '',
                      value: ''
                    })
                  "
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span>Add Filter</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  style="width:30px;height:30px;"
                  fab
                  small
                  color="orange"
                  v-on="on"
                  @click="
                    query.rules.push({
                      _key: Date.now(),
                      condition: 'and',
                      rules: []
                    })
                  "
                >
                  <v-icon>add_to_photos</v-icon>
                </v-btn>
              </template>
              <span>Add Filter Group</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  style="width:30px;height:30px;"
                  fab
                  small
                  color="red"
                  v-on="on"
                  @click="$emit('delete_query')"
                >
                  <v-icon>delete_forever</v-icon>
                </v-btn>
              </template>
              <span>Remove Filter Group</span>
            </v-tooltip>
          </v-flex>

          <template v-for="(item, i) in query.rules">
            <v-flex xs12 sm6 md4 lg3 :key="i" v-if="!item.condition">
              <FilterItem
                :rules="rules"
                :query.sync="query.rules[i]"
                @delete_query="delete_query_filter(i)"
                :key="item._key"
              >
              </FilterItem>
            </v-flex>
            <v-flex xs12 :key="i" v-else>
              <FilterGroup
                :rules="rules"
                :query.sync="query.rules[i]"
				@delete_query="delete_query_filter(i)"
                :key="item._key"
              >
              </FilterGroup>
            </v-flex>
          </template>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import FilterGroup from "./FilterGroup";
import FilterItem from "./FilterItem";

// function convert(dict_value) {
//   var return_value = [];

//   for (var key in dict_value) {
//     if (dict_value.hasOwnProperty(key)) {
//       return_value.push({
//         text: key,
//         value: dict_value[key]
//       });
//     }
//   }

//   return return_value;
// }

//const NUM_OPERATOR = convert(qb.NUM_OPERATOR);
//const STR_OPERATOR = convert(qb.STR_OPERATOR);

export default {
  name: "FilterGroup",
  props: {
    rules: {
      type: Array,
      required: true
    },
    query: {
      type: Object
    }
  },
  components: {
    FilterItem: FilterItem,
    FilterGroup: FilterGroup
  },
  data() {
    return {
      filter_options: [],
      filter_and_or: "and"
    };
  },
  watch: {},
  methods: {
    delete_query_filter(index) {
      this.query.rules.splice(index, 1);
    }
  },
  mounted() {}
};
</script>

<style>
</style>
